import { useState, useEffect } from 'react';
import { LoginContent, Input, Button, PasswordValidation, PasswordStrengthChecker } from 'Shared/components';
import { Field, Formik } from 'formik';
import { ROUTES, VALIDATION_MESSAGES } from 'Shared/enums';
import { useNavigate } from 'react-router';
import * as Yup from 'yup';
import { MainType } from './Container';

localStorage.getItem('resendMail');

const ChangePassword = (props: MainType) => {
  const { actions } = props;
  const { checkToken, recoverPassword, sendPasswordResetLink } = actions;
  const [showValidation, setShowValidation] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [isSend, setIsSend] = useState(false);
  const [isTokenActive, setIsTokenActive] = useState(false);
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const token = url.searchParams.get('token');
  const emailFromLoalStorage = localStorage.getItem('resendMail');

  const validationSchema = Yup.object().shape({
    confirmPassword: Yup.string()
      .required(VALIDATION_MESSAGES.REQUIRED)
      .min(8, 'Hasło musi składać się co najmniej z 8 znaków')
      .test('passwords-match', VALIDATION_MESSAGES.PASSWORD_MISMATCH, function (value) {
        return this.parent.password === value;
      }),
    password: Yup.string()
      .required(VALIDATION_MESSAGES.REQUIRED)
      .min(8, 'Hasło musi składać się co najmniej z 8 znaków')
      .test('Capital Letter', '', function (value) {
        return /[A-Z]/.test(value);
      })
      .test('Lowercase Letter', '', function (value) {
        return /[a-z]/.test(value);
      })
      .test('Number', '', function (value) {
        return /[0-9]/.test(value);
      })
      .test('cannot-start-with-space', VALIDATION_MESSAGES.CANNOT_START_WITH_SPACE, function (value) {
        return !value?.startsWith(' ');
      }),
  });

  useEffect(() => {
    checkToken(token)
      .then((response) => {
        response && setIsTokenActive(true);
      })
      .catch((error) => {
        error;
      });
  }, [token]);

  const handleChangePassword = (values) => {
    recoverPassword(values.password, token)
      .then((response) => {
        response && setIsSend(true);
      })
      .catch((error) => {
        error;
      });
  };
  const handleBlur = async () => {
    isPasswordValid && setShowValidation(false);
    try {
      await Yup.string()
        .required(VALIDATION_MESSAGES.REQUIRED)
        .min(8, 'Minimum 8 znaków')
        .test('Capital Letter', 'Hasło musi zawierać przynajmniej jedną wielką literę', function (value) {
          return /[A-Z]/.test(value);
        })
        .test('Lowercase Letter', 'Hasło musi zawierać przynajmniej jedną małą literę', function (value) {
          return /[a-z]/.test(value);
        })
        .test('Number', 'Hasło musi zawierać przynajmniej jedną cyfrę', function (value) {
          return /[0-9]/.test(value);
        })
        .test('cannot-start-with-space', VALIDATION_MESSAGES.CANNOT_START_WITH_SPACE, function (value) {
          return !value?.startsWith(' ');
        })
        .validate(password, { abortEarly: false });
      setShowValidation(false);
    } catch (validationError) {
      setShowValidation(true);
    }
  };

  return (
    <>
      {isTokenActive ? (
        <>
          {!isSend ? (
            <LoginContent heading="Utwórz nowe hasło">
              <Formik
                validationSchema={validationSchema}
                initialValues={{ password: '', confirmPassword: '' }}
                validateOnBlur={false}
                enableReinitialize
                onSubmit={async (values) => handleChangePassword(values)}>
                {({ handleSubmit, errors, values }) => (
                  <form onSubmit={handleSubmit}>
                    <Field
                      label="Hasło"
                      name="password"
                      placeholder=""
                      required
                      component={Input}
                      treshold={0}
                      type="password"
                      maxLength={32}
                      inputOnFocus={() => setShowValidation(true)}
                      onChange={(e) => setPassword(e)}
                      onBlur={() => {
                        handleBlur();
                      }}
                      errors={errors}
                    />
                    <PasswordStrengthChecker isHidden={!showValidation} password={values.password} />
                    <PasswordValidation
                      setIsValid={(value: boolean) => setIsPasswordValid(value)}
                      className={` ${showValidation ? 'validation-item__wrapper--show' : ''}`}
                      password={values.password}
                    />
                    <Field
                      label="Powtórz hasło"
                      name="confirmPassword"
                      placeholder=""
                      required
                      component={Input}
                      treshold={0}
                      type="password"
                      maxLength={32}
                      errors={errors}
                    />
                    <div className="login-content__button">
                      <Button label="Zapisz nowe hasło" type="submit" />
                    </div>
                  </form>
                )}
              </Formik>
            </LoginContent>
          ) : (
            <LoginContent heading="Hasło zostało zmienione ✅" descript="Twoje hasło zostało zmienione. Możesz teraz zalogować się za pomocą nowego.">
              <div className="login-content__button">
                <Button label="Zaloguj się" type="submit" onClick={() => navigate({ pathname: ROUTES.LOGIN })} />
              </div>
            </LoginContent>
          )}
        </>
      ) : (
        <LoginContent
          heading="Ups... Coś poszło nie tak ☹️"
          descript="Wygląda na to, że ten link wygasł. Aby zmienić hasło, wygeneruj link ponownie.">
          <div className="login-content__button">
            <Button label="Wyślij link ponownie" type="submit" onClick={() => sendPasswordResetLink(emailFromLoalStorage)} />
          </div>
        </LoginContent>
      )}
    </>
  );
};

export default ChangePassword;
